// TODO: want to raise to Sentry
export function handleError(error: unknown) {
  console.error(error)
}
